
    import './styles.scoped.css';
    export default {
  "layout": "awsui_layout_5gtk3_183jp_99",
  "background": "awsui_background_5gtk3_183jp_113",
  "is-overlap-disabled": "awsui_is-overlap-disabled_5gtk3_183jp_118",
  "header-background": "awsui_header-background_5gtk3_183jp_121",
  "notifications": "awsui_notifications_5gtk3_183jp_125",
  "breadcrumbs": "awsui_breadcrumbs_5gtk3_183jp_130",
  "default-padding": "awsui_default-padding_5gtk3_183jp_135",
  "header-wrapper": "awsui_header-wrapper_5gtk3_183jp_139",
  "with-divider": "awsui_with-divider_5gtk3_183jp_144",
  "content": "awsui_content_5gtk3_183jp_147",
  "has-header": "awsui_has-header_5gtk3_183jp_151",
  "is-visual-refresh": "awsui_is-visual-refresh_5gtk3_183jp_158",
  "has-default-background": "awsui_has-default-background_5gtk3_183jp_158",
  "has-notifications": "awsui_has-notifications_5gtk3_183jp_162"
};
  